import styled, { css } from 'styled-components';
import { BgColorPalette } from '@/constants/colors';

export const StyledButton = styled.button<{
  $disabled: boolean;
  $loading: boolean;
  $size: 'sm' | 'default' | 'lg';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;

  background: linear-gradient(180deg, #0138FE 0%, #28AEE8 100%);
  color: #ffffff;
  border-radius: 8px;
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);

  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);

  ${({ $size }) => {
    switch ($size) {
      case 'sm':
        return css`
          height: 32px;
          padding: 0 12px;
          font-size: 12px;
        `;
      case 'lg':
        return css`
          height: 48px;
          padding: 0 20px;
          font-size: 14px;
        `;
      case 'default':
      default:
        return css`
          height: 28px;
          padding: 0 12px;
        `;
    }
  }}

  &:hover:not(:disabled) {
    background: linear-gradient(180deg, #1F50FF 0%, #44BEEE 100%);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
  }

  &:active:not(:disabled) {
    background: linear-gradient(180deg, #0029CC 0%, #1F8EBA 100%);
    transform: scale(0.98);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    background-color: ${BgColorPalette.SECONDARY};
    color: rgba(0, 0, 0, 0.5);
  }

  &:focus-visible {
    outline: 2px solid #0138FE;
    outline-offset: 2px;
  }

  ${({ $loading }) =>
    $loading &&
    css`
      pointer-events: none;
      opacity: 0.7;
    `}
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 11px;
  height: 10px;

  svg {
    width: 100%;
    height: 100%;
  }
`;
